import { useRef, useState } from 'react';

import { useEffectOnce } from 'usehooks-ts';

import {
  FilterRequestObject,
  SearchRequestObject,
} from '@/api/elasticsearch/models';
import { similarSearchElasticApi } from '@/api/fetch/rest-similar-search-api';
import { CarouselEvents } from '@/modules/analytics/event-types';
import useRudderTrack from '@/modules/analytics/hooks/useRudderTrack';
import { CarouselType } from '@/modules/analytics/types';
import Text from '@/tayara-kit/Text';
import XCarousel from '@/tayara-kit/XCarousel';

import { IAdDetailItem, IListingItem } from '../../types';
import CompactClassifiedCard from '../RecentClassifiedsList/CompactClassifiedCard';

interface SimilarClassifiedsProps {
  query: string;
  viewedClassifiedData: IAdDetailItem;
}

const SimilarClassifieds: React.FC<SimilarClassifiedsProps> = ({
  viewedClassifiedData,
}) => {
  const [similarClassifieds, setSimilarClassifieds] = useState<IListingItem[]>(
    []
  );

  useEffectOnce(() => {
    const filterRequest: FilterRequestObject = {
      categoryId: '',
      subCategoryId: viewedClassifiedData.subCategoryId,
      adParamsMap: {},
      rangeAdParamsMap: {},
      governorate: viewedClassifiedData.location?.governorate!,
      delegation: [],
      minPrice: viewedClassifiedData.price * 0.8,
      maxPrice: viewedClassifiedData.price * 1.2,
      productTypeList: [],
      level: 0,
      state: 2,
      userid: viewedClassifiedData.publisher.id,
    };
    const searchRequest: SearchRequestObject = {
      query: '',
      offset: 0,
      limit: 20,
      sort: 0,
      filter: filterRequest,
    };

    similarSearchElasticApi(searchRequest).then(([newHits, _]) => {
      setSimilarClassifieds(
        newHits.filter((item) => item.id !== viewedClassifiedData.id)
      );
    });
  });

  const parentRef = useRef<HTMLDivElement>(null);
  const { trackCarouselClassifiedClick } = useRudderTrack();
  return (
    <>
      {similarClassifieds.length === 0 ? (
        <></>
      ) : (
        <>
          {/* <Divider orientation={Orientation.HORIZONTAL} /> */}
          <div className="my-8">
            <Text
              as="h2"
              text="Autres annonces kif-kif"
              className="text-gray-700 font-semibold text-lg"
            />
            <div className="relative pr-6" ref={parentRef}>
              <XCarousel
                portalEl={parentRef.current}
                /* onStopScroll={(progress) => {
          trackCarouselScroll(CarouselEvents.SCROLL_CAROUSEL, {
            scroll_percentage: progress,
            carousel_type: CarouselType.SIMILAR_CLASSIFIEDS,
            relative_data: null,
          });
        }} */
              >
                <ul className="h-full flex gap-px pt-1">
                  {similarClassifieds.length > 0 ? (
                    similarClassifieds.flatMap((data, index) =>
                      data.id !== viewedClassifiedData.id
                        ? [
                            <li key={index}>
                              <CompactClassifiedCard
                                onClick={() =>
                                  trackCarouselClassifiedClick(
                                    CarouselEvents.CLICK_CLASSIFIED,
                                    {
                                      carousel_type:
                                        CarouselType.SIMILAR_CLASSIFIEDS,
                                      classified_details: data,
                                      classified_position: index,
                                    }
                                  )
                                }
                                classifiedData={data}
                              />
                            </li>,
                          ]
                        : []
                    )
                  ) : (
                    <li className="m-auto font-extrabold my-11 text-2xl text-neutral-200">
                      Les annonces similaires seront affichées içi
                    </li>
                  )}
                </ul>
              </XCarousel>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SimilarClassifieds;
